<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4><u>Φορείς</u></h4>
        </div>
      </div>
      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        :data-source="organizations"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxPaging :page-size="25" />
        <DxEditing
          :allow-updating="false"
          :allow-adding="false"
          mode="row"
          :use-icons="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />
        <DxGroupPanel :visible="true" />
        <DxGrouping :auto-expand-all="false" />
        <DxStateStoring
          :enabled="false"
          type="localStorage"
          storage-key="storage2"
        />

        <DxColumn
          caption="Κωδικός"
          data-field="Id"
          data-type="integer"
          :visible="false"
        >
        </DxColumn>
        <DxColumn
          caption="Περιγραφή"
          data-field="Description"
          data-type="string"
          :visible="true"
          alignment="left"
          width="350px"
        >
        </DxColumn>
        <DxColumn
          caption="Επικοινωνία"
          data-field="ContactPerson"
          data-type="string"
          :visible="true"
          alignment="left"
          width="200px"
        >
        </DxColumn>
        <DxColumn
          caption="Νόμιμος εκπρόσωπος"
          data-field="LegalRepresentative"
          data-type="string"
          :visible="true"
          alignment="left"
          width="200px"
        >
        </DxColumn>
        <DxColumn
          caption="Δήμος"
          data-field="MunicipalityDescription"
          data-type="string"
          :visible="true"
          alignment="left"
          width="150px"
        >
        </DxColumn>
        <DxColumn
          caption="Ενεργός"
          data-field="IsActive"
          data-type="boolean"
          :visible="true"
          alignment="center"
          width="110px"
        >
        </DxColumn>
        <DxColumn type="buttons">
          <DxButton
            hint="Πληροφορίες"
            icon="info"
            :on-click="organizationInfoClick"
          />
          <DxButton
            :visible="showSelectOrganizationIcon"
            hint="Επιλογή Φορέα"
            icon="arrowright"
            :on-click="setSelectedOrganization"
          />
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import router from "../../router";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxGrouping,
  DxGroupPanel,
  DxStateStoring,
} from "devextreme-vue/data-grid";
import BackButton from "../../components/shared/backButton";
import notify from "devextreme/ui/notify";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxButton,
    BackButton,
    DxGrouping,
    DxGroupPanel,
    DxStateStoring,
    DxLoadIndicator,
  },
  data() {
    return {
      organizations: [],
      loadIndicatorVisible: false,
    };
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  methods: {
    organizationInfoClick(e) {
      router.replace(`/organization/${e.row.data.Id}`);
    },
    showSelectOrganizationIcon(e) {
      return this.isSuperAdmin || this.isAdmin;
    },
    setSelectedOrganization(e) {
      this.$store.dispatch("setSelectedOrganizationId", e.row.data.Id);

      notify(
        `Ο Φορέας άλλαξε επιτυχώς! Ο νέος επιλεγμένος Φορέας είναι ο:  ${e.row.data.Description}`,
        "success",
        4000
      );
    },
  },
  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(
      "/Organizations/GetOrganizationsForIndex"
    );
    this.organizations = res.data;
    this.loadIndicatorVisible = false;
  },
};
</script>